import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Scrollbars } from 'react-custom-scrollbars';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTimes, faSyncAlt } from '@fortawesome/free-solid-svg-icons';
import moment from 'moment';

import classes from './StatisticsGse.module.css';
import DataTable from '../../components/DataTable/DataTable';
import MyBarChart from '../../components/MyCharts/MyBarChart';
import MyLineChart from '../../components/MyCharts/MyLineChart';
import Loader from '../../components/UI/Loader/Loader';
import PrimaryAutocomplete from '../../components/UI/PrimaryAutocomplete/PrimaryAutocomplete';
import PrimaryButton from '../../components/UI/PrimaryButton/PrimaryButton';
import Block from '../../components/Block/Block';
import { formatDate } from '../../store/utilities';
import * as actions from '../../store/actions/index';

class StatisticsGse extends Component {
    state = {
        timeframe: 'all',
        selectedYear: null,
        selectedAirport: null,
        selectedEquipment: null,
        selectedGse: null,
        tableOptions: {
            initialPage: 0,
            pageSize: 5,
            searchText: '',
            defaultSort: { column: 2, order: 'desc' },
        },
    };

    componentDidMount() {
        this.props.onGetGsePrefilterStatistics();
    }
    componentWillUnmount() {
        this.props.onResetStatistics();
    }

    updateTableOptions = (property, value) => {
        let tableOptions = { ...this.state.tableOptions };
        tableOptions[property] = value;

        this.setState({ tableOptions: tableOptions });
    };

    changeAirport = (airport) => {
        let value = null;
        if (airport) value = airport.value;
        this.setState({ selectedAirport: value });
    };
    changeEquipment = (equipment) => {
        let value = null;
        if (equipment) value = equipment.value;
        this.setState({ selectedEquipment: value });
    };
    changeGse = (gse) => {
        let timeframe = this.state.timeframe;
        let selectedYear = this.state.selectedYear;
        if (gse) {
            timeframe = 'all';
            selectedYear = null;
        }
        this.setState({ timeframe: timeframe, selectedYear: selectedYear, selectedGse: gse });
    };

    getFilteredGseOptions = () => {
        let options;

        if (this.state.selectedAirport && this.state.selectedEquipment) {
            options = this.props.gseOptions.filter((o) => o.airportId === this.state.selectedAirport && o.equipmentType === this.state.selectedEquipment);
        } else if (!this.state.selectedAirport && this.state.selectedEquipment) {
            options = this.props.gseOptions.filter((o) => o.equipmentType === this.state.selectedEquipment);
        } else if (this.state.selectedAirport && !this.state.selectedEquipment) {
            options = this.props.gseOptions.filter((o) => o.airportId === this.state.selectedAirport);
        } else {
            options = this.props.gseOptions;
        }

        return options;
    };

    getStats = () => {
        if (!this.state.selectedGse) return;
        this.props.onGetGseStatistics(this.state.selectedGse.value);
    };

    getData = (type) => {
        if (!this.props.gseStatistics) return;

        if (this.state.timeframe === 'all') {
            return this.props.gseStatistics[type];
        } else if (this.state.timeframe === 'year') {
            let itemsPerMonth = {
                1: { dtMonth: `JAN-${this.state.selectedYear}`, val: null },
                2: { dtMonth: `FEB-${this.state.selectedYear}`, val: null },
                3: { dtMonth: `MAR-${this.state.selectedYear}`, val: null },
                4: { dtMonth: `APR-${this.state.selectedYear}`, val: null },
                5: { dtMonth: `MAY-${this.state.selectedYear}`, val: null },
                6: { dtMonth: `JUN-${this.state.selectedYear}`, val: null },
                7: { dtMonth: `JUL-${this.state.selectedYear}`, val: null },
                8: { dtMonth: `AUG-${this.state.selectedYear}`, val: null },
                9: { dtMonth: `SEP-${this.state.selectedYear}`, val: null },
                10: { dtMonth: `OCT-${this.state.selectedYear}`, val: null },
                11: { dtMonth: `NOV-${this.state.selectedYear}`, val: null },
                12: { dtMonth: `DEC-${this.state.selectedYear}`, val: null },
            };

            for (let i = 0; i < this.props.gseStatistics[type].length; i++) {
                const item = this.props.gseStatistics[type][i];
                const dtMonth = item.dtMonth;

                const year = moment(dtMonth, 'MMM-YYYY').format('yyyy');
                if (year == this.state.selectedYear) {
                    const monthIndex = moment(dtMonth, 'MMM-YYYY').format('M');
                    itemsPerMonth[monthIndex] = item;
                }
            }

            const itemsArr = Object.values(itemsPerMonth);

            return itemsArr;
        }
    };
    getLineData = (type) => {
        if (!this.props.gseStatistics) return;

        if (this.state.timeframe === 'all') {
            return this.props.gseStatistics[type];
        } else if (this.state.timeframe === 'year') {
            let yearItems = [];
            for (let i = 0; i < this.props.gseStatistics[type].length; i++) {
                const item = this.props.gseStatistics[type][i];
                const dt = item.dt;

                const year = moment(new Date(dt)).format('yyyy');
                if (year == this.state.selectedYear) {
                    yearItems.push(item);
                }
            }

            return yearItems;
        }
    };

    changeTimeframe = (timeframe) => {
        this.setState({ timeframe: timeframe });
    };

    changeYear = (year) => {
        this.setState({ selectedYear: year });
    };

    getBarFields = () => {
        let tableFields = [
            {
                title: 'Month',
                field: 'dtMonth',
                defaultSort: this.state.tableOptions.defaultSort.column === 0 ? this.state.tableOptions.defaultSort.order : null,
            },
            {
                title: 'Value',
                field: 'val',
                render: (rowData) => (rowData.val ? Math.round(rowData.val * 100) / 100 : rowData.val),
                defaultSort: this.state.tableOptions.defaultSort.column === 0 ? this.state.tableOptions.defaultSort.order : null,
            },
        ];

        return tableFields;
    };

    getLineFields = () => {
        let tableFields = [
            {
                title: 'Date',
                field: 'dt',
                render: (rowData) => formatDate(rowData.dt),
                defaultSort: this.state.tableOptions.defaultSort.column === 0 ? this.state.tableOptions.defaultSort.order : null,
            },
            {
                title: 'Value',
                field: 'val',
                render: (rowData) => (rowData.val ? Math.round(rowData.val * 100) / 100 : rowData.val),
                defaultSort: this.state.tableOptions.defaultSort.column === 0 ? this.state.tableOptions.defaultSort.order : null,
            },
        ];

        return tableFields;
    };

    render() {
        const barFields = this.getBarFields();
        const lineFields = this.getLineFields();
        const refuelingEqData = this.getData('refuelingEq');
        const refuelingEqFlightsData = this.getData('refuelingEqFlights');
        const opertTimeEqData = this.getData('opertTimeEq');
        const opertTimeEqFlightsData = this.getData('opertTimeEqFlights');
        const serviceRecordsData = this.getLineData('serviceRecords');
        const tyreRecordsData = this.getLineData('tyreRecords');
        const batteryRecordsData = this.getLineData('batteryRecords');
        const actualFCData = this.getLineData('actualFC');

        const filteredGseOptions = this.getFilteredGseOptions();

        const filtersSpace = (
            <div className={classes.FiltersSpace}>
                <div className={classes.FilterCol}>
                    <span className={classes.FilterName}>Airport</span>
                    <PrimaryAutocomplete options={this.props.airportOptions} changed={(e, value) => this.changeAirport(value)} short narrow />
                </div>
                <div className={classes.FilterCol}>
                    <span className={classes.FilterName}>Equipment</span>
                    <PrimaryAutocomplete options={this.props.equipmentOptions} changed={(e, value) => this.changeEquipment(value)} short narrow />
                </div>
                <div className={classes.FilterCol}>
                    <span className={classes.FilterName}>GSE</span>
                    <PrimaryAutocomplete options={filteredGseOptions} changed={(e, value) => this.changeGse(value)} short narrow />
                </div>
                <PrimaryButton disabled={this.state.selectedGse === null} clicked={() => this.getStats()} iconButton>
                    <FontAwesomeIcon icon={faSyncAlt} />
                </PrimaryButton>
            </div>
        );

        let page = (
            <React.Fragment>
                {filtersSpace}

                <div className={classes.PageTitle}>
                    <h1>GSE statistics</h1>
                    <div className={classes.MarginLeftAuto}>
                        <div className={classes.ActionButtonsWrapper}>
                            <div className={classes.CancelButton} onClick={() => this.props.history.push('/statistics')}>
                                <FontAwesomeIcon icon={faTimes} />
                            </div>
                        </div>
                    </div>
                </div>
                <div className={classes.PageContent}>
                    <Loader show={this.props.loading} />
                </div>
            </React.Fragment>
        );

        if (this.props.loading === false && this.props.gseStatistics) {
            page = (
                <React.Fragment>
                    {filtersSpace}
                    <div className={classes.PageTitle}>
                        <h1>GSE statistics</h1>
                        <div className={classes.MarginLeftAuto}>
                            <div className={classes.ActionButtonsWrapper}>
                                <div className={classes.CancelButton} onClick={() => this.props.history.push('/statistics')}>
                                    <FontAwesomeIcon icon={faTimes} />
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className={classes.PageContent}>
                        <Scrollbars style={{ width: '100%', height: '100%' }}>
                            <div className={classes.ScrollInner}>
                                <Block title='Refueling consumption'>
                                    <div className={classes.ChartWrapper}>
                                        <MyBarChart
                                            data={refuelingEqData}
                                            years={this.props.gseStatisticsYears.refuelingEq}
                                            name='Refueling consumption'
                                            xDataKey='dtMonth'
                                            valKey='val'
                                            changeYear={this.changeYear}
                                            changeTimeframe={this.changeTimeframe}
                                            timeframe={this.state.timeframe}
                                            selectedYear={this.state.selectedYear}
                                            withAverage
                                            yLabel='Liters'
                                        />
                                    </div>

                                    <DataTable
                                        data={refuelingEqData}
                                        columns={barFields}
                                        withExport
                                        withSearch
                                        tableOptions={this.state.tableOptions}
                                        updateTableOptions={(property, value) => this.updateTableOptions(property, value)}
                                        noActions
                                    />
                                </Block>

                                <div className={classes.VerticalSpacer}></div>

                                <Block title='Actual fuel consumption'>
                                    <div className={classes.ChartWrapper}>
                                        <MyLineChart
                                            data={actualFCData}
                                            refuelingData={refuelingEqData}
                                            operationalData={opertTimeEqData}
                                            years={this.props.gseStatisticsYears.actualFC}
                                            name='Actual fuel consumption'
                                            xDataKey='dt'
                                            valKey='val'
                                            changeYear={this.changeYear}
                                            changeTimeframe={this.changeTimeframe}
                                            timeframe={this.state.timeframe}
                                            selectedYear={this.state.selectedYear}
                                            withAverage
                                            yLabel='Liters / hour'
                                        />
                                    </div>

                                    <DataTable
                                        data={actualFCData}
                                        columns={lineFields}
                                        withExport
                                        withSearch
                                        tableOptions={this.state.tableOptions}
                                        updateTableOptions={(property, value) => this.updateTableOptions(property, value)}
                                        noActions
                                    />
                                </Block>

                                <div className={classes.VerticalSpacer}></div>

                                <Block title='Refueling consumption per flight'>
                                    <div className={classes.ChartWrapper}>
                                        <MyBarChart
                                            data={refuelingEqFlightsData}
                                            years={this.props.gseStatisticsYears.refuelingEqFlights}
                                            name='Refueling consumption per flight'
                                            xDataKey='dtMonth'
                                            valKey='val'
                                            changeYear={this.changeYear}
                                            changeTimeframe={this.changeTimeframe}
                                            timeframe={this.state.timeframe}
                                            selectedYear={this.state.selectedYear}
                                            withAverage
                                            yLabel='Liters / flight'
                                        />
                                    </div>

                                    <DataTable
                                        data={refuelingEqFlightsData}
                                        columns={barFields}
                                        withExport
                                        withSearch
                                        tableOptions={this.state.tableOptions}
                                        updateTableOptions={(property, value) => this.updateTableOptions(property, value)}
                                        noActions
                                    />
                                </Block>

                                <div className={classes.VerticalSpacer}></div>

                                <Block title='Operational time'>
                                    <div className={classes.ChartWrapper}>
                                        <MyBarChart
                                            data={opertTimeEqData}
                                            years={this.props.gseStatisticsYears.opertTimeEq}
                                            name='Operational time'
                                            xDataKey='dtMonth'
                                            valKey='val'
                                            changeYear={this.changeYear}
                                            changeTimeframe={this.changeTimeframe}
                                            timeframe={this.state.timeframe}
                                            selectedYear={this.state.selectedYear}
                                            withAverage
                                            yLabel='Hours'
                                        />
                                    </div>

                                    <DataTable
                                        data={opertTimeEqData}
                                        columns={barFields}
                                        withExport
                                        withSearch
                                        tableOptions={this.state.tableOptions}
                                        updateTableOptions={(property, value) => this.updateTableOptions(property, value)}
                                        noActions
                                    />
                                </Block>

                                <div className={classes.VerticalSpacer}></div>

                                <Block title='Operational time per flight'>
                                    <div className={classes.ChartWrapper}>
                                        <MyBarChart
                                            data={opertTimeEqFlightsData}
                                            years={this.props.gseStatisticsYears.opertTimeEqFlights}
                                            name='Operational time per flight'
                                            xDataKey='dtMonth'
                                            valKey='val'
                                            changeYear={this.changeYear}
                                            changeTimeframe={this.changeTimeframe}
                                            timeframe={this.state.timeframe}
                                            selectedYear={this.state.selectedYear}
                                            withAverage
                                            yLabel='Hours / flight'
                                        />
                                    </div>

                                    <DataTable
                                        data={opertTimeEqFlightsData}
                                        columns={barFields}
                                        withExport
                                        withSearch
                                        tableOptions={this.state.tableOptions}
                                        updateTableOptions={(property, value) => this.updateTableOptions(property, value)}
                                        noActions
                                    />
                                </Block>

                                <div className={classes.VerticalSpacer}></div>

                                <Block title='Service frequency'>
                                    <div className={classes.ChartWrapper}>
                                        <MyLineChart
                                            data={serviceRecordsData}
                                            years={this.props.gseStatisticsYears.serviceRecords}
                                            name='Operational time between services'
                                            xDataKey='dt'
                                            valKey='val'
                                            changeYear={this.changeYear}
                                            changeTimeframe={this.changeTimeframe}
                                            timeframe={this.state.timeframe}
                                            selectedYear={this.state.selectedYear}
                                            withAverage
                                            yLabel='Hours'
                                        />
                                    </div>

                                    <DataTable
                                        data={serviceRecordsData}
                                        columns={lineFields}
                                        withExport
                                        withSearch
                                        tableOptions={this.state.tableOptions}
                                        updateTableOptions={(property, value) => this.updateTableOptions(property, value)}
                                        noActions
                                    />
                                </Block>

                                <div className={classes.VerticalSpacer}></div>

                                <Block title='Tyre replacement frequency'>
                                    <div className={classes.ChartWrapper}>
                                        <MyLineChart
                                            data={tyreRecordsData}
                                            years={this.props.gseStatisticsYears.tyreRecords}
                                            name='Operational time between tyre replacement'
                                            xDataKey='dt'
                                            valKey='val'
                                            changeYear={this.changeYear}
                                            changeTimeframe={this.changeTimeframe}
                                            timeframe={this.state.timeframe}
                                            selectedYear={this.state.selectedYear}
                                            withAverage
                                            yLabel='Hours'
                                        />
                                    </div>

                                    <DataTable
                                        data={tyreRecordsData}
                                        columns={lineFields}
                                        withExport
                                        withSearch
                                        tableOptions={this.state.tableOptions}
                                        updateTableOptions={(property, value) => this.updateTableOptions(property, value)}
                                        noActions
                                    />
                                </Block>

                                <div className={classes.VerticalSpacer}></div>

                                <Block title='Battery replacement frequency'>
                                    <div className={classes.ChartWrapper}>
                                        <MyLineChart
                                            data={batteryRecordsData}
                                            years={this.props.gseStatisticsYears.batteryRecords}
                                            name='Operational time between battery replacement'
                                            xDataKey='dt'
                                            valKey='val'
                                            changeYear={this.changeYear}
                                            changeTimeframe={this.changeTimeframe}
                                            timeframe={this.state.timeframe}
                                            selectedYear={this.state.selectedYear}
                                            withAverage
                                            yLabel='Hours'
                                        />
                                    </div>

                                    <DataTable
                                        data={batteryRecordsData}
                                        columns={lineFields}
                                        withExport
                                        withSearch
                                        tableOptions={this.state.tableOptions}
                                        updateTableOptions={(property, value) => this.updateTableOptions(property, value)}
                                        noActions
                                    />
                                </Block>
                            </div>
                        </Scrollbars>
                    </div>
                </React.Fragment>
            );
        }
        return page;
    }
}

const mapStateToProps = (state) => {
    return {
        loading: state._system.loading,
        gseOptions: state.statistics.gseOptions,
        airportOptions: state.statistics.airportOptions,
        equipmentOptions: state.statistics.equipmentOptions,
        gseStatistics: state.statistics.gseStatistics,
        gseStatisticsYears: state.statistics.gseStatisticsYears,
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        onGetGsePrefilterStatistics: () => dispatch(actions.getGsePrefilterStatistics()),
        onGetGseStatistics: (gseId) => dispatch(actions.getGseStatistics(gseId)),
        onResetStatistics: () => dispatch(actions.resetStatistics()),
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(StatisticsGse);
